// Who took a call (CU-869fnzh44):
//   POST /api/v1/practices/{p}/calls/{rowId}/team-member/
//   { source: 'pill' }                                   "I'm on this call"
//   { source: 'manual', practice_user_id: <id | null> }  "Who took this call?" (Call Logs manage; null = nobody)
// Both answer with the updated Call Logs row.
import { callApi } from 'src/utils/apiCall';
import newIdempotencyKey from 'src/utils/idempotencyKey';

export const teamMemberUrl = (practiceId, rowId) => `/api/v1/practices/${practiceId}/calls/${encodeURIComponent(rowId)}/team-member/`;

export const MANAGE_MESSAGE = 'You need Call Logs manage access to change who took a call. Ask an admin.';

const refusal = (response, field) => {
  if (response.status === 403) return MANAGE_MESSAGE;
  const data = response.data || {};
  const pick = (v) => (Array.isArray(v) ? v[0] : v);
  const detail = pick(data.detail) || pick(data[field]) || (Array.isArray(data) ? data[0] : null);
  return typeof detail === 'string' && detail ? detail : 'This could not be saved.';
};

// { ok: false, alreadyNamed: true, row } 409 already_named · { ok: true, data: row } saved · { ok: false, uncertain: true } no reply or a 5xx: it may have
// saved, so never say "failed" · { ok: false, status, message } refused. One `idempotencyKey`
// per user choice, reused on a retry of the same choice.
async function post(practiceId, rowId, body, field, idempotencyKey) {
  if (!practiceId || !rowId) return { ok: false, message: 'This call cannot be changed.' };
  const options = { headers: { 'Idempotency-Key': idempotencyKey || newIdempotencyKey() }, suppressServerErrorDispatch: true, timeout: 30000 };
  const response = await callApi(teamMemberUrl(practiceId, rowId), 'POST', body, false, options);
  if (response?.ok) return { ok: true, data: response.data };
  if (!response || response.status === 0 || response.status >= 500) return { ok: false, uncertain: true };
  // A stronger source (desk, handset) already names someone: not an error, the row says who.
  if (response.status === 409 && response.data?.code === 'already_named') {
    return { ok: false, alreadyNamed: true, status: 409, message: refusal(response, field), row: response.data.row || null };
  }
  return { ok: false, status: response.status, message: refusal(response, field) };
}

export const claimCall = (practiceId, rowId, { idempotencyKey } = {}) => post(practiceId, rowId, { source: 'pill' }, 'source', idempotencyKey);

export const assignCallPerson = (practiceId, rowId, practiceUserId, { idempotencyKey } = {}) => post(
  practiceId, rowId, { source: 'manual', practice_user_id: practiceUserId ?? null }, 'practice_user_id', idempotencyKey,
);
